<template>
  <div class="perfect-bu-config" v-loading="pageLoading || loading">
    <ContentHeader :showBack="true" />
    <div class="content-container">
      <h4>主题信息</h4>
      <div class="content">
        <div class="bu-row">
          <div class="bu-title">主题名称</div>
          <div class="bu-content">
            {{originThemeDefineDTO.themeName || '' }}
            <span
              v-if="tradePerfectThemeDefineDTO.themeStatusName"
            >({{ tradePerfectThemeDefineDTO.themeStatusName }})</span>
          </div>
        </div>
        <div class="bu-row">
          <div class="bu-title">渠道</div>
          <div class="bu-content">{{originThemeDefineDTO.channelName || ''}}</div>
        </div>
        <div class="bu-row">
          <div class="bu-title">所属BU</div>
          <div class="bu-content">{{orgName || ''}}</div>
        </div>
        <div class="bu-row">
          <div class="bu-title require">活动时间</div>
          <div class="bu-content">
            <el-date-picker
              size="mini"
              v-model="buConfigInfo.startDate"
              align="right"
              type="date"
              placeholder="开始时间"
              value-format="timestamp"
              :clearable="false"
              :picker-options="disableStartDate"
              @change="checkDate('start')"
            ></el-date-picker>&nbsp;&nbsp;&nbsp;&nbsp;
            至
            &nbsp;&nbsp;&nbsp;&nbsp;
            <el-date-picker
              size="mini"
              v-model="buConfigInfo.endDate"
              align="right"
              type="date"
              placeholder="结束时间"
              value-format="timestamp"
              :clearable="false"
              :picker-options="disableEndDate"
              @change="checkDate('end')"
              default-time="23:59:59"
            ></el-date-picker>
          </div>
          <div class="reminder">截止时间为活动结束时间</div>
        </div>
        <div class="bu-row">
          <div class="bu-title require">陈列追踪方式</div>
          <div class="bu-content">
            <el-button size="mini" type="primary" class="exec-cycle-btn">售点追踪</el-button>
          </div>
        </div>
        <div class="bu-row">
          <div class="bu-title require">最少执行时间（天）</div>
          <div class="bu-content">
            <el-input-number v-model="buConfigInfo.execDaysMin" :min="originThemeDefineDTO.execDaysMin" :precision="0" placeholder="请输入"></el-input-number>
          </div>
          <div class="reminder">不能小于{{originThemeDefineDTO.execDaysMin}}天</div>
        </div>
        <div class="bu-row">
          <div class="bu-title require">最低打卡次数（天/次）</div>
          <div class="bu-content">
            <el-input-number
              v-model="buConfigInfo.execDaysCycle"
              :max="originThemeDefineDTO.execDaysCycle"
              :precision="0"
              placeholder="请输入"
            ></el-input-number>
          </div>
          <div class="reminder">最大值：{{originThemeDefineDTO.execDaysCycle}}</div>
        </div>
        <div class="bu-row">
          <div class="bu-title require">费用返还方式</div>
          <div class="bu-content">
            <div class="checkbox-info">
              <el-checkbox-group v-model="bonusTypeScope" v-for="item in bonusTypeScopeList" :key="item.value" class="checkbox-wrapper">
                <el-checkbox-button
                  class="bonus-type-btn"
                  size="mini"
                  :label="item.value"
                  v-if="item.type === 0"
                  @change="setBonusTypeScope"
                >{{item.key}}</el-checkbox-button>
              </el-checkbox-group>
              <span style="font-size:12px;color:#409eff" v-if="checkBonusTypeScopeType(bonusTypeScopeList, 0)">
                <i class="el-icon-info"></i> 无交易售点
              </span>
            </div>
            <div class="checkbox-info">
              <el-checkbox-group v-model="bonusTypeScope" v-for="item in bonusTypeScopeList" :key="item.value" class="checkbox-wrapper">
                <el-checkbox-button class="bonus-type-btn" size="mini" :label="item.value" v-if="item.type === 1" @change="setBonusTypeScope">{{item.key}}</el-checkbox-button>
              </el-checkbox-group>
              <span style="font-size:12px;color:#409eff" v-if="checkBonusTypeScopeType(bonusTypeScopeList, 1)">
                <i class="el-icon-info"></i> 有交易售点
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 任务列表 是否勾选任务-->
      <div class="task">
        <div class="task-wrapper">
          <div class="task-content" v-for="(item, index) in taskCheckedList" :key="item.key" v-show="item.key !== '05' || (item.key === '05' && (bonusTypeScope.includes('04') || bonusTypeScope.includes('05')))">
              <div class="task-title">{{ item.title }}</div>
              <el-checkbox class="taskCheckbox" v-model="item.checked" @change="cancelDialog(item,index)">启用</el-checkbox>
          </div>
        </div>
      </div>
      <!-- tab栏 -->
      <el-tabs v-if="taskShowList.length > 0" v-model="activeName" @tab-click="handleClick">
        <template v-for="item in taskShowList">
          <el-tab-pane :key="item.key" :label="item.title" :name="item.title"></el-tab-pane>
        </template>
      </el-tabs>
      <!-- 选项卡 -->
      <div v-show="activeName==='堆箱任务'">
        <PerfectBuConfigDesign
          ref="boxTask"
          class="tab-content"
          :originThemeDefineDTO="originThemeDefineDTO"
          :primaryData="boxObj.mixinPackScopeList || []"
          :regionListByBu="regionListByBu"
          :regionCancelConfirm="(tradePerfectThemeDefineDTO.themeStatus || 0) > 0"
          :defineCountMap="defineCountMap"
        ></PerfectBuConfigDesign>
        <PerfectBuCombinationDesign
          ref="boxCombination"
          class="tab-content tab-combination"
          style="margin-top: 10px;"
          :title="'堆箱组合陈列套餐'"
          :originThemeDefineDTO="originThemeDefineDTO"
          :primaryData="boxObj.mixinDisplayScopeList || []"
          :customBrandList="customBrandList"
          :regionListByBu="regionListByBu"
          :regionCancelConfirm="(tradePerfectThemeDefineDTO.themeStatus || 0) > 0"
          :defineCountMap="defineCountMap"
        ></PerfectBuCombinationDesign>
      </div>
      <div v-show="activeName==='货架任务'">
        <PerfectBuFreezerDesign
          ref="goodsShelfTask"
          class="tab-content"
          :title="'货架必备品/排面数'"
          :originThemeDefineDTO="originThemeDefineDTO"
          :primaryData="goodsShelfObj.mandatoryScopeList || []"
          :customBrandList="customBrandList"
          :regionListByBu="regionListByBu"
          :regionCancelConfirm="(tradePerfectThemeDefineDTO.themeStatus || 0) > 0"
          :defineCountMap="defineCountMap"
        ></PerfectBuFreezerDesign>
        <PerfectBuCombinationDesign
          ref="goodsShelfCombination"
          class="tab-content tab-combination"
          style="margin-top: 10px;"
          :title="'货架组合陈列套餐'"
          :originThemeDefineDTO="originThemeDefineDTO"
          :primaryData="goodsShelfObj.mixinDisplayScopeList || []"
          :customBrandList="customBrandList"
          :regionListByBu="regionListByBu"
          :regionCancelConfirm="(tradePerfectThemeDefineDTO.themeStatus || 0) > 0"
          :defineCountMap="defineCountMap"
        ></PerfectBuCombinationDesign>
      </div>
      <div v-show="activeName==='冰柜任务'">
        <PerfectBuFreezerDesign
          ref="freezerTask"
          class="tab-content"
          :title="'冰柜必备品/排面数'"
          :originThemeDefineDTO="originThemeDefineDTO || []"
          :primaryData="freezerObj.mandatoryScopeList"
          :customBrandList="customBrandList"
          :regionListByBu="regionListByBu"
          :regionCancelConfirm="(tradePerfectThemeDefineDTO.themeStatus || 0) > 0"
          :defineCountMap="defineCountMap"
        ></PerfectBuFreezerDesign>
        <PerfectBuCombinationDesign
          ref="freezerCombination"
          class="tab-content tab-combination"
          style="margin-top: 10px;"
          :title="'冰柜组合陈列套餐'"
          :originThemeDefineDTO="originThemeDefineDTO"
          :primaryData="freezerObj.mixinDisplayScopeList || []"
          :customBrandList="customBrandList"
          :regionListByBu="regionListByBu"
          :regionCancelConfirm="(tradePerfectThemeDefineDTO.themeStatus || 0) > 0"
          :defineCountMap="defineCountMap"
        ></PerfectBuCombinationDesign>
      </div>
      <div v-show="activeName==='STR任务'">
        <div class="str-task">STR任务明细由SD TM进行配置</div>
      </div>
    </div>
    <div class="operate">
      <el-button
        v-if="!this.$route.query.status || this.$route.query.status === 0 || this.$route.query.status === '0'"
        type="danger"
        @click="handleConfirm(0)"
      >保存</el-button>
      <el-button type="danger" @click="handleConfirm(1)">提交</el-button>
    </div>
  </div>
</template>

<script>
import tradeApi from '@/api/trade'
import moment from 'moment'
import ContentHeader from '@/components/content-header'
import PerfectBuConfigDesign from './components/perfect-bu-config-design'
import PerfectBuCombinationDesign from './components/perfect-bu-combination-design'
import PerfectBuFreezerDesign from './components/perfect-bu-freezer-design'
export default {
  name: 'perfect-bu-config',
  components: {
    ContentHeader,
    PerfectBuConfigDesign,
    PerfectBuCombinationDesign,
    PerfectBuFreezerDesign
  },
  data () {
    return {
      themeDefineId: '',
      rogCode: '',
      buConfigInfo: {
        originDefineId: '',
        orgCodes: '',
        startDate: '',
        endDate: '',
        execWeekChooseType: '01',
        taskTypeScope: '',
        tradePerfectTaskDefineList: [],
        fullNum: undefined
      },
      bonusTypeScopeList: [],
      regionListByBu: [],
      orgList: [],
      originThemeDefineDTO: {},
      tradePerfectThemeDefineDTO: {}, // 修改时默认数据
      switchValue: [], // 修改时执行周数数据
      boxObj: {}, // 修改堆箱默认数据
      goodsShelfObj: {}, // 修改货架默认数据
      freezerObj: {}, // 修改冰柜默认数boxObj
      disableStartDate: {},
      disableEndDate: {},
      loading: false,
      pageLoading: false,
      customBrandList: [], // 子品牌对应放入品牌数组中
      taskDefineIdInfo: {}, // 修改时储存任务id
      taskNameMap: {
        '01': '堆箱任务',
        '02': '货架任务',
        '03': '冰柜任务',
        '05': 'STR任务'
      },
      taskCheckedList: [],
      activeName: '堆箱任务',
      defineCountMap: {},
      submitLoading: false,
      checkedResult: true, // 校验
      bonusTypeScope: []
    }
  },
  watch: {
    // 勾选任务
    taskCheckedList: {
      deep: true,
      immediate: true,
      handler () {
        let flag = this.taskCheckedList.every(item => {
          return !item.checked
        })
        if (flag) {
          this.activeName = ''
        }
        for (let i = 0; i < this.taskCheckedList.length; i++) {
          if (this.taskCheckedList[i].checked) {
            this.activeName = this.taskCheckedList[i].title
            return
          }
        }
      }
    }
  },
  computed: {
    orgName () {
      return this.orgList[0] ? this.orgList[0].orgName : this.tradePerfectThemeDefineDTO.orgName
    },
    isUpdate () {
      return this.$route.query.type === 'update' && Number(this.$route.query.status) === 200
    },
    taskShowList () {
      return this.taskCheckedList.filter(task => {
        return task.checked
      })
    }
  },
  created () {
    this.$store.dispatch('getDictByName', 'tradePerfectMandatorySpecsMap')
    this.$store.dispatch('getDictByName', 'tradePerfectScopeDetailSpecMap')
    this.themeDefineId = this.$route.query.themeDefineId
    this.orgCode = this.$route.query.orgCode || ''
    this.getBuThemeDefineInfo()
    this.getDefineCount()
  },
  methods: {
    // 检查活动日期
    checkDate (status) {
      if (this.buConfigInfo.startDate && this.buConfigInfo.endDate && this.buConfigInfo.startDate > this.buConfigInfo.endDate) {
        this.$message.warning({
          message: '活动结束时间应大于活动开始时间',
          duration: 8000
        })
        if (status === 'start') {
          this.buConfigInfo.startDate = ''
        }
        if (status === 'end') {
          this.buConfigInfo.endDate = ''
        }
      }
    },

    // 获取默认数据
    getBuThemeDefineInfo () {
      this.pageLoading = true
      let params = { themeDefineId: this.themeDefineId, orgCode: this.orgCode }
      tradeApi.getBuThemeDefineInfo(params).then(res => {
        this.pageLoading = false
        if (res.data.resultCode === '0') {
          this.orgList = res.data.resultData.orgList || []
          this.originThemeDefineDTO = res.data.resultData.originThemeDefineDTO || []
          this.originThemeDefineDTO.taskTypeScope.split(',').map(originTask => {
            this.taskCheckedList.push({
              key: originTask,
              title: this.taskNameMap[originTask],
              checked: false,
              showTask: true
            })
          })
          this.buConfigInfo.execDaysMin = this.originThemeDefineDTO.execDaysMin
          this.buConfigInfo.execDaysCycle = this.originThemeDefineDTO.execDaysCycle
          if (res.data.resultData.tradePerfectThemeDefineDTO) { // 设置修改时，默认数据
            this.tradePerfectThemeDefineDTO = res.data.resultData.tradePerfectThemeDefineDTO
            this.buConfigInfo = this.tradePerfectThemeDefineDTO
            this.getRegionListByBu(this.tradePerfectThemeDefineDTO.orgCode)// 获取区域多选框列表，新建与修改时orgCode存在位置不同
            this.setOriginThemeDefineDTO() // 处理修改时所需数据
          } else {
            this.getRegionListByBu(this.orgList[0].orgCode)
            this.buConfigInfo.startDate = this.originThemeDefineDTO.startDate
            this.buConfigInfo.endDate = this.originThemeDefineDTO.endDate
          }
          // 处理陈列方式，费用返还方式，赠酒sku数据
          this.bonusTypeScopeList = this.getBonusTypeScopeList(this.originThemeDefineDTO.bonusTypeScope)
          this.getActiveData()// 处理活动开始时间限制
          // 处理匹配品牌与子品牌
          let brandList = Object.assign([], this.originThemeDefineDTO.brandList)
          let subBrandList = Object.assign([], this.originThemeDefineDTO.subBrandList)
          if (brandList.length && subBrandList.length) {
            brandList.forEach(brand => {
              this.$set(brand, 'subBrandList', [])
              subBrandList.forEach(subBrand => {
                if (brand.brandId === subBrand.parentBrandId) {
                  brand.subBrandList.push(subBrand)
                }
              })
            })
          }

          this.customBrandList = brandList

          this.$nextTick(() => {
            this.setAllInfo()
          })
        }
      })
        .catch(() => {
          this.pageLoading = false
        })
    },
    // 修改时所需数据
    setOriginThemeDefineDTO () {
      this.buConfigInfo.startDate = this.tradePerfectThemeDefineDTO.startDate
      this.buConfigInfo.endDate = this.tradePerfectThemeDefineDTO.endDate
      this.buConfigInfo.execDaysMin = this.tradePerfectThemeDefineDTO.execDaysMin
      this.buConfigInfo.execDaysCycle = this.tradePerfectThemeDefineDTO.execDaysCycle
      this.setTabData() // 设置tab任务栏是否选中
      this.bonusTypeScope = this.tradePerfectThemeDefineDTO.bonusTypeScope.split(',')

      // 处理各个task组件中已配置的数据
      this.tradePerfectThemeDefineDTO.tradePerfectTaskDefineList.forEach(item => {
        if (item.taskType === '01') {
          this.taskDefineIdInfo.boxId = item.taskDefineId
          this.boxObj = item
        }
        if (item.taskType === '02') {
          this.taskDefineIdInfo.goodsShelfId = item.taskDefineId
          this.goodsShelfObj = item
        }
        if (item.taskType === '03') {
          this.taskDefineIdInfo.freezerId = item.taskDefineId
          this.freezerObj = item
        }
        if (item.taskType === '05') {
          this.taskDefineIdInfo.STRId = item.taskDefineId
        }
      })
    },
    setAllInfo () {
      this.$refs.boxTask.setInfo()
      this.$refs.boxCombination.setInfo()
      this.$refs.goodsShelfTask.setInfo()
      this.$refs.goodsShelfCombination.setInfo()
      this.$refs.freezerTask.setInfo()
      this.$refs.freezerCombination.setInfo()
    },
    getActiveData () {
      let startDate = this.originThemeDefineDTO.startDate
      let endDate = this.originThemeDefineDTO.endDate
      this.disableStartDate = {
        disabledDate (time) {
          return endDate < time.getTime() || time.getTime() < startDate
        }
      }
      this.disableEndDate = {
        disabledDate (time) {
          if (startDate < Date.parse(new Date())) {
            return endDate < time.getTime() || time.getTime() < Date.parse(new Date()) - 86400000
          } else {
            return endDate < time.getTime() || time.getTime() < startDate
          }
        }
      }
    },
    // 处理陈列方式，费用返还方式，赠酒sku数据
    getTaskTypeScopeList (list) {
      let newList = list.split(',').map(item => {
        item = { value: item }
        if (item.value === '01') {
          item.key = '售点追踪'
        } else if (item.value === '02') {
          item.key = '销售追踪'
        }
        return item
      })
      return newList
    },
    getBonusTypeScopeList (list, type) {
      let newList = list.split(',').map(item => {
        item = { value: item }
        switch (item.value) {
          case '01':
            item.key = '线上现金返还'
            item.type = 0
            break
          case '02':
            item.key = '线下现金返还'
            item.type = 0
            break
          case '03':
            item.key = '线下免费酒返还'
            item.type = 0
            break
          case '04':
            item.key = '先蜂购线上免费酒返还'
            item.type = 1
            break
          case '05':
            item.key = '先蜂购线上折扣金返还'
            item.type = 1
            break
        }
        return item
      })
      return newList
    },
    // 费用返还方式是否包含交易售点选项
    checkBonusTypeScopeType (list, mode) {
      return list.find(item => {
        return item.type === mode
      })
    },
    setTabData () {
      // 处理tabCheckBox选中情况
      this.taskCheckedList.forEach(taskItem => {
        taskItem.checked = false
      })
      this.tradePerfectThemeDefineDTO.taskTypeScope.split(',').forEach(item => {
        this.taskCheckedList.forEach(taskItem => {
          if (taskItem.key === item) {
            taskItem.checked = true
          }
        })
      })
    },
    cancelDialog (row, index) {
      if (row.checked === false && (this.tradePerfectThemeDefineDTO.themeStatus || 0) > 0) {
        this.$nextTick(() => {
          this.taskCheckedList[index].checked = true
        })
        this.$confirm('若禁用该任务类型，则选择该任务类型的活动都会被禁用！', '是否禁用该任务类型？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          this.taskCheckedList[index].checked = false
        }).catch(() => {
        })
      }
      // 2.0 新增
      // 如果之前配置过该类型任务启用时需确认
      if (this.tradePerfectThemeDefineDTO.tradePerfectTaskDefineList && this.tradePerfectThemeDefineDTO.tradePerfectTaskDefineList.length) {
        let isExist = this.tradePerfectThemeDefineDTO.tradePerfectTaskDefineList.find(item => {
          return item.taskType === row.key
        })
        if (row.checked === true && (this.tradePerfectThemeDefineDTO.themeStatus || 0) > 0 && isExist) {
          this.$nextTick(() => {
            this.taskCheckedList[index].checked = false
          })
          this.$confirm('启用后，下属Region的相关活动仍在禁用状态，需手动启用！', '是否启用该任务类型？', {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(() => {
            this.taskCheckedList[index].checked = true
          }).catch(() => {
          })
        }
      }
    },
    // 获取区域列表
    getRegionListByBu (code) {
      let params = {
        buCode: code
      }
      this.$store
        .dispatch('getRegionListByBu', params)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.regionListByBu = res.data.resultData.regionList || []
            for (let i = 0; i < this.regionListByBu.length; i++) {
              this.regionListByBu[i].orgName = this.regionListByBu[i].orgName.substring(0, this.regionListByBu[i].orgName.indexOf('|'))
              if (this.regionListByBu[i].orgName.indexOf('HQ') !== -1) {
                this.regionListByBu.splice(i, 1)
                i--
              }
            }
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 获取区域被活动引用情况
    getDefineCount () {
      tradeApi.getDefineCount(this.themeDefineId)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.defineCountMap = res.data.resultData.defineCountMap || {}
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    setBonusTypeScope () {
      this.buConfigInfo.bonusTypeScope = this.bonusTypeScope.sort((a, b) => {
        return a - b
      }).join()
      if (this.buConfigInfo.bonusTypeScope.indexOf('04') === -1 && this.buConfigInfo.bonusTypeScope.indexOf('05') === -1) {
        this.taskCheckedList.forEach(item => {
          if (item.key === '05') { item.checked = false }
        })
      }
    },

    handleClick (tab, event) {
    },

    checkMainData (status) {
      // status 0保存，1提交
      this.buConfigInfo.saveFlag = status
      this.buConfigInfo.originDefineId = this.themeDefineId
      this.buConfigInfo.orgCodes = this.orgList[0] ? this.orgList[0].orgCode : this.tradePerfectThemeDefineDTO.orgCode

      if (!this.buConfigInfo.execDaysMin) {
        this.checkedResult = false
        this.$message.warning({
          message: '请填写最少执行时间',
          duration: 8000
        })
        return
      }

      if (this.buConfigInfo.execDaysMin < this.originThemeDefineDTO.execDaysMin) {
        this.checkedResult = false
        this.$message.warning({
          message: '活动最低执行时间不能小于上级配置的执行时间',
          duration: 8000
        })
        return
      }

      let diffDate = moment(this.buConfigInfo.endDate).diff(moment(this.buConfigInfo.startDate), 'days', true)
      if (this.buConfigInfo.execDaysMin > Math.floor(diffDate) + 1) {
        this.$message.warning('最少执行时间大于活动时间')
        return
      }

      if (!this.buConfigInfo.execDaysCycle) {
        this.checkedResult = false
        this.$message.warning({
          message: '请填写最低打卡频次',
          duration: 8000
        })
        return
      }

      if (this.buConfigInfo.execDaysCycle > this.originThemeDefineDTO.execDaysCycle) {
        this.checkedResult = false
        this.$message.warning({
          message: '活动最低打卡频次不能小于上级配置的最低打卡频次',
          duration: 8000
        })
        return
      }

      if (!this.buConfigInfo.bonusTypeScope || this.buConfigInfo.bonusTypeScope === undefined) {
        this.checkedResult = false
        this.$message.warning({
          message: '请选择费用返还方式',
          duration: 8000
        })
        // eslint-disable-next-line no-useless-return
        return
      }

      // // 费用返还方式选择先蜂购， 活动结束时间应为月最后一天
      // if (this.buConfigInfo.bonusTypeScope.indexOf('04') !== -1 || this.buConfigInfo.bonusTypeScope.indexOf('05') !== -1) {
      //   let year = new Date(this.buConfigInfo.endDate).getFullYear()
      //   let month = new Date(this.buConfigInfo.endDate).getMonth() + 1
      //   let newMonth = ++month
      //   if (newMonth === 13) {
      //     year++
      //     month = 1
      //   }
      //   // 当月最后一天
      //   let date = new Date(`${year}/${month}`).getTime() - 86400000
      //   if (this.buConfigInfo.endDate < date) {
      //     this.checkedResult = false
      //     this.$message.warning('费用返还方式已选择先蜂购，活动结束时间必须为该月最后一天')
      //     // eslint-disable-next-line no-useless-return
      //     // return
      //   }
      // }
    },
    checkTradePerfectTaskDefineList (status) {
      this.taskCheckedList.forEach(item => {
        if (item.checked === true && item.key === '01') {
          let checkedResult = this.$refs.boxTask.checkData(status) && this.$refs.boxCombination.checkData(status)
          if (checkedResult === false) {
            this.checkedResult = checkedResult
          }
        } else if (item.checked === true && item.key === '02') {
          let checkedResult = this.$refs.goodsShelfTask.checkData(status) && this.$refs.goodsShelfCombination.checkData(status)
          if (checkedResult === false) {
            this.checkedResult = checkedResult
          }
        } else if (item.checked === true && item.key === '03') {
          let checkedResult = this.$refs.freezerTask.checkData(status) && this.$refs.freezerCombination.checkData(status)
          if (checkedResult === false) {
            this.checkedResult = checkedResult
          }
        }
      })
    },
    // 提交
    handleConfirm (status) {
      this.checkedResult = true
      this.checkMainData(status) // 设置并检查
      if (!this.checkedResult) {
        return
      }
      this.checkTradePerfectTaskDefineList(status)
      if (!this.checkedResult) {
        return
      }
      // if (this.checkedResult) {
      //   console.log('校验通过')
      //   return
      // }
      this.groupData()
      this.pageLoading = true
      let api = this.$route.query.type === 'update' ? 'perfectThemeDefineBuUpdate' : 'perfectThemeDefineBu'
      let hint = this.$route.query.type === 'update' ? '修改套餐' : '生成套餐'
      if (this.$route.query.type === 'update') {
        this.buConfigInfo.themeDefineId = this.themeDefineId
      }
      tradeApi[api](this.buConfigInfo)
        .then(res => {
          this.pageLoading = false
          if (res.data.resultCode === '0') {
            this.$message.success(`${hint}成功`)
            this.$router.replace('/trade/perfect-bu-config-list')
          }
        })
        .catch(() => {
          this.pageLoading = false
        })
    },
    // 组合数据
    groupData () {
      let params = []
      this.buConfigInfo.taskTypeScope = []
      this.buConfigInfo.taskTypeScope = this.taskCheckedList.filter(item => {
        return item.checked === true
      }).map(item => {
        if (item.key === '01') {
          params.push({
            taskDefineId: this.taskDefineIdInfo.boxId,
            taskType: '01',
            taskName: '堆箱',
            mixinPackScopeList: this.$refs.boxTask.getMixinPackInfo('01') || [],
            mixinDisplayScopeList: this.$refs.boxCombination.getMixinDisplayScopeInfo('01') || []
          })
        } else if (item.key === '02') {
          params.push({
            taskDefineId: this.taskDefineIdInfo.goodsShelfId,
            taskType: '02',
            taskName: '货架',
            mandatoryScopeList: this.$refs.goodsShelfTask.getMandatoryInfo('02') || [],
            mixinDisplayScopeList: this.$refs.goodsShelfCombination.getMixinDisplayScopeInfo('02') || []
          })
        } else if (item.key === '03') {
          params.push({
            taskDefineId: this.taskDefineIdInfo.freezerId,
            taskType: '03',
            taskName: '冰柜',
            mandatoryScopeList: this.$refs.freezerTask.getMandatoryInfo('03') || [],
            mixinDisplayScopeList: this.$refs.freezerCombination.getMixinDisplayScopeInfo('03') || []
          })
        } else if (item.key === '05') {
          params.push({
            taskDefineId: this.taskDefineIdInfo.STRId,
            taskType: '05',
            taskName: 'STR'
          })
        }
        return item.key
      }).join(',')
      this.buConfigInfo.tradePerfectTaskDefineList = params
    }
  }
}
</script>

<style lang="scss" scoped>
.clearStyle {
  line-height: 0px;
}
.content-container {
  h4 {
    font-weight: bold;
  }
}
.content {
  font-size: 16px;
  margin: 30px auto;
  padding: 20px 40px;
  background-color: #fff;
  border-radius: 10px;
  .bu-row + .bu-row {
    border-top: 1px solid #eee;
  }
  .bu-row {
    // height: 60px;
    display: flex;
    position: relative;
    line-height: 60px;
    .bu-title {
      display: flex;
      font-weight: bold;
      width: 190px;
      padding-left: 10px;
    }
    .bu-content {
      color: #101010;
      width: 900px;
      font-size: 14px;
      ::v-deep .el-input-number__decrease,
      ::v-deep .el-input-number__increase {
        display: none;
      }
      .el-input-number {
        width: 80px;
        &::v-deep .el-input__inner {
          padding: 0;
          height: 30px;
        }
      }
      .el-button {
        // width: 80px;
        height: 30px;
      }
      .exec-cycle-btn {
        height: 30px;
        padding: 7px 15px;
        border-radius: 4px;
        margin-right: 25px;
        // border-left: 1px solid #dcdfe6;
        font-size: 14px;
      }

      .checkbox-info {
        display: flex;
        flex-basis: 80%;
        flex-wrap: wrap;
        align-items: center;
        // padding: 10px 0;
        &::v-deep .el-checkbox-button__inner,
        &::v-deep .el-radio-button__inner,
        .exec-cycle-btn {
          height: 30px;
          padding: 7px 15px;
          border-radius: 4px;
          margin-right: 25px;
          // border-left: 1px solid #dcdfe6;
          font-size: 14px;
        }
        .checkbox-wrapper {
          position: relative;
          .task-range-btn {
            //   margin-right: 25px;
            &::v-deep .el-checkbox-button__inner {
              width: 80px;
            }
          }
          .bonus-type-btn {
            &::v-deep .el-checkbox-button__inner {
              width: 170px;
            }
          }
        }
      }
    }
    .reminder {
      position: absolute;
      font-size: 12px;
      top: 16px;
      left: 10px;
      font-weight: 600;
      color: #c8102d;
    }
  }
}
// 任务多选样式
.task {
  display: flex;
  // justify-content: space-around;
  align-content: center;
  margin: 20px 20px;
  border-radius: 10px;

  .task-wrapper {
    display: flex;
    justify-content: flex-start;
    align-content: center;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    line-height: 45px;
    color: #333;
    overflow: hidden;
    text-align: center;

    .task-content {
      align-content: center;
      // width: 30%;
      flex: 1;
      margin: 0 10px;
      height: 90px;
      background-color: #fff;
      border-radius: 10px;
      .task-title {
        font-size: 16px;
      }
    }
  }
  ::v-deep .el-checkbox__inner::after {
    height: 15px;
    left: 10px;
    top: 2px;
  }
}
.taskCheckbox {
  // text-align: center;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // margin-top: 8px;
  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
  ::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #409eff;
    border-color: #409eff;
    border-radius: 50px;
    width: 25px;
    height: 25px;
  }
  ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #409eff;
    border-radius: 50px;
  }
  ::v-deep .el-checkbox.is-bordered.is-checked {
    border-color: #409eff;
    border-radius: 50px;
  }

  ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #409eff;
    border-radius: 50px;
  }
  ::v-deep .el-checkbox__input .el-checkbox__inner {
    height: 25px;
    width: 25px;
    border-radius: 50px;
  }
  ::v-deep .el-checkbox__input:hover .el-checkbox__inner {
    border-color: #409eff;
    border-radius: 50px;
  }
}

// // 任务tabs样式
::v-deep .el-tabs {
  .el-tabs__header {
    border-bottom: none;
  }
  .el-tabs__nav {
    border: none;
    border-radius: 10px 10px 0px 0px;
    background-color: #fff;
    padding: 10px 20px 0px;
  }
  .el-tabs__nav-wrap::after {
    background-color: #f3f5f9;
  }
  .el-tabs__active-bar {
    margin: 0 20px 0;
    background-color: rgb(234, 84, 5);
  }
  .el-tabs__item.is-active {
    font-weight: 700;
    color: rgb(234, 84, 5);
  }
  .el-tabs__item:hover {
    color: rgb(234, 84, 5);
  }
}
.tab-content {
  font-size: 16px;
  margin: -15px auto 0;
  padding: 20px 20px;
  background-color: #fff;
  border-radius: 0px 10px 10px 10px;
}
.tab-combination {
  border-radius: 10px !important;
}
// 加号
.add-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  margin: 12px 0 0 0;
  border-radius: 10px;
  background-color: #409eff;
  color: #fff;
  cursor: pointer;
}
// 弹窗
.select-dialog {
  .dialog-form {
    line-height: 1;
    .btn {
      margin-top: 3px;
    }
  }
  .dialog-table {
    ::v-deep .el-table__header-wrapper .el-checkbox__input::after {
      content: '全选';
      position: absolute;
      margin: 0 0 0 10px;
      font-weight: 700;
      color: rgb(144, 147, 153);
    }
  }
}
.operate {
  width: 300px;
  margin: 0px auto 40px;
  display: flex;
  justify-content: space-around;
}
// 必填
.require {
  position: relative;
  &::before {
    content: '*';
    font-size: 20px;
    width: 5px;
    height: 5px;
    color: red;
    position: absolute;
    top: 0;
    left: -10px;
  }
}
.str-task {
  padding: 20px;
  background-color: #fff;
  margin-top: -15px;
  border-radius: 0px 10px 10px 10px;
}
</style>
